import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export const getAll = (agentId) =>
  http
    .get('/agents/notifications/agent?agentId=' + agentId)
    .then(handleResponse);

export const read = (agentNotifyId) =>
  http
    .put('agents/notifications/read?agentNotifyId=' + agentNotifyId)
    .then(handleResponse);

export const unread = (agentNotifyId) =>
  http
    .put('agents/notifications/not/read?agentNotifyId=' + agentNotifyId)
    .then(handleResponse);

export const readAll = (agentId) =>
  http
    .put('agents/notifications/read/all?agentId=' + agentId)
    .then(handleResponse);
